<template>
  <div
    data-component="agent-profile-popup"
    @click.stop
  >
    <agent-profile-popup-info
      :avatar="avatar"
      :agent="agent"
      :multi-user="multiUser"
    />

    <div class="divider" />

    <div class="options">
      <div
        v-for="option of options"
        :key="option.key"
        :data-option="option.key"
        @click="$emit('option-click', option.key)"
      >
        {{ option.label }}
      </div>

      <div
        data-option="sign-out"
        @click="$emit('sign-out')"
      >
        {{ $t('HITL.common.labels.sign-out') }}
      </div>

      <div
        v-if="appVersion"
        class="app-version-label"
      >
        {{ $t('HITL.common.labels.app-version', { version: appVersion }) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { AvatarOptions } from '@onereach/hitl-base-avatars';

import { IAgent, IAgentMultiUser } from '@/types';
import AgentProfilePopupInfo from './AgentProfilePopupInfo.vue';
import { AgentProfileOption } from '../../types';

export default defineComponent({
  name: 'AgentProfilePopup',
  components: { AgentProfilePopupInfo },
  props: {
    avatar: {
      type: Object as PropType<AvatarOptions>,
      default: undefined,
    },
    agent: {
      type: Object as PropType<IAgent>,
      required: true,
    },
    multiUser: {
      type: Object as PropType<IAgentMultiUser>,
      default: undefined,
    },
    options: {
      type: Array as PropType<AgentProfileOption[]>,
      default: () => [],
    },
    appVersion: {
      type: String,
      default: '',
    },
  },
  emits: ['option-click', 'sign-out'],
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='agent-profile-popup'] {
  @include basic-popup;
  display: flex;
  flex-direction: column;
  width: 22.5rem;

  .divider {
    flex: 0 0 1px;
    background: var(--or-c-surface-variant);
    margin-bottom: var(--s-2);
  }

  .options {
    display: flex;
    flex-direction: column;
    padding-bottom: var(--s-4);

    [data-option],
    .app-version-label {
      padding: 0 var(--s-5);
    }

    [data-option] {
      @include text-overflow;

      display: flex;
      align-items: center;
      height: 2.125rem;
      color: var(--or-c-on-background);
      font-size: var(--fs-1);
      cursor: pointer;

      &:hover {
        background: var(--or-c-primary-opacity-0-08);
      }
    }

    .app-version-label {
      margin-top: var(--s-2);
      color: var(--or-c-outline);
      line-height: 1.5;
      font-size: var(--fs-0);
    }
  }
}
</style>
